export enum PeriodicityEnum {
  DAY = "DAY",
  WEEK = "WEEK",
  MONTH = "MONTH",
  YEAR = "YEAR",
}
export const getPeriodicity = (recurringUnit?: PeriodicityEnum) => {
  switch (recurringUnit) {
    case PeriodicityEnum.DAY:
      return "Diário"
    case PeriodicityEnum.WEEK:
      return "Semanal"
    case PeriodicityEnum.MONTH:
      return "Mensal"
    case PeriodicityEnum.YEAR:
      return "Anual"
    default:
      return "Indefinido"
  }
}
